import { useCallback } from 'react';
import { useGetUserFullNameWithFallback } from './useGetUserFullNameWithFallback';

type P = {
  firstName?: null | string;
  lastName?: null | string;
};

export const useGetUserNameWithFallback = () => {
  const getFullNameWithFallback = useGetUserFullNameWithFallback();

  return useCallback(
    ({ firstName, lastName }: P) => getFullNameWithFallback({ firstName, lastName }),
    [getFullNameWithFallback],
  );
};
